import { useState } from 'react';

export const usePagination = () => {
	const [pagination, setPagination] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalResults, setTotalResults] = useState(null);

	const handlePagination = (value) => {
		setPagination(value);
	};

	return {
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
		handlePagination,
	};
};
